<template>
  <div class="navigation-menu-dropdown">
    <menu-item :title="title" :icon="icon" :on-click="toggle" :selected="false"
               aria-haspopup="true" :aria-expanded="String(open)" :aria-controls="openAreaId">
      <img class="arrow" :class="{ open }" :src="require('@/assets/icons/navigation-menu/dropdown-arrow.svg')" alt="">
    </menu-item>
    <transition name="menu">
      <div class="open-area-wrapper" v-if="open" :id="openAreaId">
        <div class="open-area">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Segment from '@/Segment';
import MenuItem from '@/base-components/app-header/MenuItem';

export default {
  name: 'NavigationMenuDropdown',
  components: {
    MenuItem,
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    openAreaId() {
      return `navigation-menu-dropdown-${this._uid}`;
    },
  },
  created() {
    this.open = false;
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    segmentEventSuffix: {
      type: String,
      required: false,
    },
  },
  methods: {
    toggle() {
      this.open = !this.open;
      if (this.segmentEventSuffix) {
        Segment.trackUserInteraction(`NavigationMenuDropdown_${this.segmentEventSuffix}_Clicked`, { open: this.open });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@riseupil/base-ui/src/scss/spacings';
.navigation-menu-dropdown {
  .open-area-wrapper {
    display: grid;
    padding-top: $ri-spacing-sm;
    .open-area {
      min-height: 0;
      display: flex;
      flex-direction: column;
      row-gap: $ri-spacing-sm;
    }
  }
  .arrow {
    width: 15px;
    height: 15px;
    transform: rotate(-90deg);
    transition: transform 0.2s ease-in-out;
    &.open {
      transform: rotate(90deg);
    }
  }

  .menu-enter, .menu-leave-to {
    grid-template-rows: 0fr;
    opacity: 0;
    padding-top: 0;
  }

  .menu-enter-to, .menu-leave {
    grid-template-rows: 1fr;
    opacity: 1;
    padding-top: $ri-spacing-sm;
  }

  .menu-enter-active, .menu-leave-active {
    transition: grid-template-rows 0.3s ease-out, opacity 0.3s ease-out, padding-top 0.3s ease-out;
    overflow: hidden;
  }
}
</style>
